/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 관리자 승인 요구 페이지
 * 버전 : 1.0
 * 파일명 : SignUpDenyPage.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-14, 강동형 : 저작권 추가, 버튼 조건부 렌더링 추가
 */

import { useEffect, useState } from 'react'
import styled from 'styled-components';
import CheckIconIMG from 'src/assets/images/CheckIcon_Large.png';
import { toast } from 'react-toastify';
import { TempUserStore } from 'src/stores/UserInfoStore';
import { useNavbarStore, usePwaStore } from 'src/stores/UIStore';
import { useNavigate } from 'react-router-dom';
import { Icon_Inform_Teal } from 'src/components/common/CommonIcons';
import icon_download  from 'src/assets/images/Icon_Download.svg'
import InstallGuideTap from './InstallGuideTap';
import { LoginPageTabType } from './LoginPage';

const SignUpDenyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Title = styled.h1`
  text-align: center;
  font-weight: bold;
  font-size: 18px;
`;

const CheckButton = styled.button<{ selected: boolean }>`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? ' #39B95B': 'gray')}; // 선택 여부에 따라 배경색을 설정합니다.
  color: white;
  cursor: pointer;
  /* margin-right: 7px; */
`;

const CheckIcon = styled.img`
    width: 80%;
    height: auto;
`

const Welcome = styled.p`
    padding: 30px 0px;
    font-weight: 700;
    font-size: 22px;
    margin: auto;
    text-align: center;
`

const WelcomeText = styled.span`
    font-size: 18px;
    font-weight: 400;
    text-align: center;
`

const WelcomeContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 62px;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  padding-top: 50px;
  width: 100%;
  height: 100%;
`
const InstallButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  padding:10px 16.5px;
  max-height: 44px;
  background-color: #E9F4F4;
  color: #229596;
  border: 1px solid #229596;
  border-radius: 5px;
  max-width: 90%;
  white-space: nowrap;
`


const SignUpDeny = () => {
    const userName = TempUserStore((state)=>state.userName)
    const reset = TempUserStore((state)=>state.reset)
    const setNavField= useNavbarStore((state)=>state.setField)
    const navigate = useNavigate()
    const deferredPrompt = usePwaStore((state)=>state.deferredPrompt)
    const clearDeferredPrompt = usePwaStore((state)=>state.clearDeferredPrompt)
    const whichDevice = usePwaStore((state)=>state.whichDevice)
    const isInsatalled = usePwaStore((state)=>state.isInsatalled)
    const [tab,setTab] = useState<LoginPageTabType>('Login')
   useEffect(()=>{
      setNavField('isvisible',false)
        return()=>{
          reset()
          setNavField('isvisible',true)
        }
    },[])
  
    const createShortCut = async ()=>{
      if (!deferredPrompt) {
        toast.error('바로가기가 이미 있습니다.')
        navigate('/')
        return;
      }
    
      deferredPrompt.prompt(); // 설치 다이얼로그 표시
    
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        // console.log('사용자가 설치함');
      } else {
        // console.log('사용자가 설치 취소함');
      }
    
      clearDeferredPrompt(); // 재사용 불가
      navigate('/')
    }

  return (
    <>
    {tab === 'Login' &&
      <SignUpDenyContainer>
        <Title>회원가입 완료</Title>
        <WelcomeContainer>
            <CheckButton selected={true}>
                <CheckIcon src={CheckIconIMG} alt="" />
            </CheckButton>
            <Welcome>
                {userName}님 환영합니다!
            </Welcome>
            <WelcomeText>
                정상적으로 회원가입 되었습니다.<br/>
                <strong>관리자 승인 후</strong> 서비스를 이용하실 수 있습니다.<br/>
                홈화면에 바로가기 아이콘을 추가하고,<br/>
                간편하게 사용해보세요.
            </WelcomeText>
            <ButtonContainer>
            {whichDevice === 'ios' ?  
                (isInsatalled === false && 
                    <InstallButton onClick={()=>setTab('InstallGuide')} style={{padding:'10px 46px'}}>
                        <Icon_Inform_Teal/>
                        홈 화면 바로가기 설치 가이드
                    </InstallButton>)
                :
                (deferredPrompt && 
                    <InstallButton onClick={createShortCut}>
                        <img src={icon_download} alt="" />
                        홈 화면에 설치하기
                    </InstallButton>
                )
            }
            </ButtonContainer>
        </WelcomeContainer>
    </SignUpDenyContainer>
    }
    {tab === 'InstallGuide' && <InstallGuideTap setTab={setTab}/>}
    </>
  )
}

export default SignUpDeny